import React from "react";
import {
    UserOutlined,
    HomeOutlined,
    UnorderedListOutlined,
    AppstoreAddOutlined,
    LoginOutlined,
    UserAddOutlined,
    LogoutOutlined,
    StopOutlined,
    StopFilled,
    DribbbleCircleFilled,
    DribbbleOutlined,
    PlusCircleOutlined,
    MinusCircleOutlined,
    PauseCircleOutlined,
    SettingOutlined
} from '@ant-design/icons';

const menu = [
    {
        title: 'Home',
        link: '/home',
        icon: <HomeOutlined />,
        logedIn: '2',
    },
    {
        title: 'Deposit',
        link: '/deposit',
        icon: <PlusCircleOutlined />,
        logedIn: '1',
    },
    {
        title: 'Withdraw',
        link: '/withdraw',
        icon: <MinusCircleOutlined />,
        logedIn: '1',
    },
    {
        title: 'Send Coin',
        link: '/send coin',
        icon: <PauseCircleOutlined />,
        logedIn: '1',
    },
    {
        title: 'Account',
        link: '/account',
        icon: <UserOutlined />,
        logedIn: '1',
        subMenu: [
            {
                title: 'Account Info',
                link: '/account info'
            },
            {
                title: 'Account Update',
                link: '/account update'
            },
            {
                title: 'Password Update',
                link: '/password update'
            },
            {
                title: 'Club Update',
                link: '/club update'
            },
            {
                title: '6 Digit Pin',
                link: '/six digit pin'
            }
        ]
    },
    {
        title: 'Statement',
        link: '/statement',
        icon: <UnorderedListOutlined />,
        logedIn: '1',
        subMenu: [
            {
                title: 'Work History',
                link: '/work history'
            },
            {
                title: 'Deposit History',
                link: '/deposit history'
            },
            {
                title: 'Withdraw History',
                link: '/withdraw history'
            },
            {
                title: 'Send Coin History',
                link: '/send coin history'
            },
            {
                title: 'Transection History',
                link: '/transection history'
            },
            // {
            //     title: 'Per/Total Transection History',
            //     link: '/per total transection history'
            // }
        ]
    },
    {
        title: 'Settings',
        link: '/settings option',
        icon: <SettingOutlined />,
        logedIn: '1',
    },
    // {
    //     title: 'Cricket',
    //     link: '/pot one by c on',
    //     icon: <StopFilled />,
    //     logedIn: '2',
    // },
    // {
    //     title: 'Football',
    //     link: '/pot one by f do',
    //     icon: <DribbbleCircleFilled />,
    //     logedIn: '2',
    // },
    // {
    //     title: 'Tennis',
    //     link: '/pot one by t no',
    //     icon: <StopOutlined />,
    //     logedIn: '2',
    // },
    // {
    //     title: 'Table Tannis',
    //     link: '/pot one by v yes',
    //     icon: <DribbbleOutlined />,
    //     logedIn: '2',
    // },
    {
        title: 'LogIn',
        link: '/login',
        icon: <LoginOutlined />,
        logedIn: '0',
    },
    {
        title: 'Sign Up',
        link: '/sign up',
        icon: <UserAddOutlined />,
        logedIn: '0',
    },
    {
        title: 'Log Out',
        link: '/',
        icon: <LogoutOutlined />,
        logedIn: '1',
    }
]

export default menu;